module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if( player.stats ) { 
__p+='\n	<h4>Form</h4>\n	<div class="stats-block">\n		<div class="stats-info">\n			<h5>Games Played</h5>\n			<p>'+
((__t=( player.stats.games_played ))==null?'':_.escape(__t))+
'</p>\n		</div>\n		<div class="stats-info">\n			<h5>Average Points</h5>\n			<p>'+
((__t=( player.stats.avg_points ))==null?'':_.escape(__t))+
'</p>\n		</div>\n		<div class="stats-info">\n			<h5>Last 3 Average</h5>\n			<p>'+
((__t=( player.stats.last_3_avg ))==null?'':_.escape(__t))+
'</p>\n		</div>\n		<div class="stats-info">\n			<h5>Last 5 Average</h5>\n			<p>'+
((__t=( player.stats.last_5_avg ))==null?'':_.escape(__t))+
'</p>\n		</div>\n	</div>\n\n	<h4>Price</h4>\n	<div class="stats-block">\n		<div class="stats-info">\n			<h5>Price</h5>\n			<!--<p class="'+
((__t=( player.cost_season_diff > 0 ? 'positive' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( player.cost_season_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">-->\n			<p>\n				'+
((__t=( _.currencyFormat(player.stats.prices[current_round.id], '$', true) ))==null?'':_.escape(__t))+
'\n			</p>\n		</div>\n		<div class="stats-info">\n			<h5>Total Change</h5>\n			<p class="'+
((__t=( player.cost_season_diff > 0 ? 'positive' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( player.cost_season_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n				'+
((__t=( _.currencyFormat(player.cost_season_diff, '$', true) ))==null?'':_.escape(__t))+
'\n			</p>\n		</div>\n		<div class="stats-info">\n			<h5>Round '+
((__t=( current_round.id ))==null?'':_.escape(__t))+
' Change</h5>\n			<p class="'+
((__t=( player.cost_round_diff > 0 ? 'positive' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( player.cost_round_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n				'+
((__t=( _.currencyFormat(player.cost_round_diff, '$', true) ))==null?'':_.escape(__t))+
'\n			</p>\n		</div>\n		<div class="stats-info">\n			<h5>Dollars Per Avg Pts</h5>\n			<p>\n				'+
((__t=( _.currencyFormat(player.stats.cost_divided_by_avg_points, '$', true) ))==null?'':_.escape(__t))+
'\n			</p>\n		</div>\n	</div>\n\n	<h4>Performance By Round</h4>\n	<div class="stats-block">\n		<div class="stats-info">\n			<h5>Round '+
((__t=( points_round.id ))==null?'':_.escape(__t))+
' Points</h5>\n			<p>'+
((__t=( player.stats.points_last_round === '' ? '-' : player.stats.points_last_round ))==null?'':_.escape(__t))+
'</p>\n		</div>\n		<div class="stats-info">\n			<h5>Round '+
((__t=( points_round.id ))==null?'':_.escape(__t))+
' Rank</h5>\n			<p>'+
((__t=( _.result(player, 'stats.ranks['+points_round.id+']', '-') ))==null?'':_.escape(__t))+
'</p>\n		</div>\n		<div class="stats-info">\n			<h5>Highest Round</h5>\n			<p>'+
((__t=( player.stats.high_score ))==null?'':_.escape(__t))+
'</p>\n		</div>\n		<div class="stats-info">\n			<h5>Lowest Round</h5>\n			<p>'+
((__t=( player.stats.low_score ))==null?'':_.escape(__t))+
'</p>\n		</div>\n	</div>\n\n	<h4 class="coach-stat">\n		Next Opponent: '+
((__t=( _.result(player, 'opponent.name') ))==null?'':_.escape(__t))+
' ('+
((__t=( _.result(player, 'venue.name') ))==null?'':_.escape(__t))+
')\n	</h4>\n	<div class="stats-block coach-stat">\n		<div class="stats-info">\n			<h5>Round '+
((__t=( current_round.id ))==null?'':_.escape(__t))+
' Projected</h5>\n			';
 if(has_assistant_coach) { 
__p+='\n				<p class="coach-stat">'+
((__t=( _.result(player, 'stats.proj_scores['+current_round.id+']', '-') ))==null?'':_.escape(__t))+
'</p>\n			';
 } else { 
__p+='\n				<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n			';
 } 
__p+='\n		</div>\n		<div class="stats-info">\n			<h5>Round '+
((__t=( current_round.id ))==null?'':_.escape(__t))+
' Break Even</h5>\n			';
 if(has_assistant_coach) { 
__p+='\n				<p class="coach-stat">'+
((__t=( _.result(player, 'stats.break_evens['+current_round.id+']', '-') ))==null?'':_.escape(__t))+
'</p>\n			';
 } else { 
__p+='\n				<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n			';
 } 
__p+='\n		</div>\n		<div class="stats-info">\n			<h5>Round '+
((__t=( current_round.id ))==null?'':_.escape(__t))+
' Buys</h5>\n			';
 if(has_assistant_coach) { 
__p+='\n				<p class="coach-stat">'+
((__t=( _.result(player, 'stats.transfers['+last_completed.id+'].in', '-') ))==null?'':_.escape(__t))+
'</p>\n			';
 } else { 
__p+='\n				<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n			';
 } 
__p+='\n		</div>\n		<div class="stats-info">\n			<h5>Round '+
((__t=( current_round.id ))==null?'':_.escape(__t))+
' Sells</h5>\n			';
 if(has_assistant_coach) { 
__p+='\n				<p class="coach-stat">'+
((__t=( _.result(player, 'stats.transfers['+last_completed.id+'].out', '-') ))==null?'':_.escape(__t))+
'</p>\n			';
 } else { 
__p+='\n				<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n			';
 } 
__p+='\n		</div>\n	</div>\n';
 } 
__p+='';
}
return __p;
};
